var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoTopicList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 157,
    viewBox: "0 0 126 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.25 1H8.75C4.46979 1 1 4.46979 1 8.75V148.25C1 152.53 4.46979 156 8.75 156H117.25C121.53 156 125 152.53 125 148.25V8.75C125 4.46979 121.53 1 117.25 1Z",
    stroke: "#FF9D2E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5747 42.8501H104.075",
    stroke: "#FF9D2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5747 81.6001H104.075",
    stroke: "#FF9D2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5747 120.35H104.075",
    stroke: "#FF9D2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.175 42.0752C44.175 47.9434 39.4183 52.7002 33.55 52.7002C27.6818 52.7002 22.925 47.9434 22.925 42.0752C22.925 36.207 27.6818 31.4502 33.55 31.4502C39.4183 31.4502 44.175 36.207 44.175 42.0752Z",
    fill: "#FF9D2E",
    fillOpacity: 0.05,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.175 80.8252C44.175 86.6934 39.4183 91.4502 33.55 91.4502C27.6818 91.4502 22.925 86.6934 22.925 80.8252C22.925 74.957 27.6818 70.2002 33.55 70.2002C39.4183 70.2002 44.175 74.957 44.175 80.8252Z",
    fill: "#FF9D2E",
    fillOpacity: 0.05,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.175 119.575C44.175 125.443 39.4183 130.2 33.55 130.2C27.6818 130.2 22.925 125.443 22.925 119.575C22.925 113.707 27.6818 108.95 33.55 108.95C39.4183 108.95 44.175 113.707 44.175 119.575Z",
    fill: "#FF9D2E",
    fillOpacity: 0.05,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTopicList);
export default __webpack_public_path__ + "static/media/noTopicList.5ff12ae7377173f63279810f1ef4947d.svg";
export { ForwardRef as ReactComponent };